<template>
  <v-dialog
    hide-overlay
    :overlay-opacity="0"
    transition="fade-transition"
    persistent
    ref="dialog"
    :value="!!isOpen"
    absolute
  >
    <div class="card-overlay" @click="$refs.dialog.animateClick()"/>

    <v-card style="width: 560px" class="" v-if="isOpen">
<!--      <template-->
<!--        v-if="selectedTheme !== undefined && Object.keys(selectedTheme).length && selectedTheme.screenshot_url"-->
<!--      >-->
<!--        <v-img-->
<!--          height="285px"-->
<!--          width="100%"-->
<!--          position="top center"-->
<!--          :src="selectedTheme.screenshot_url"-->
<!--        />-->
<!--        <v-divider />-->
<!--      </template>-->

      <v-card-title class="pb-0 flex justify-space-between align-center">
        <h4 class="font-weight-light">
          {{ $t('heading.onboarding.domainDnsVerificationModal.title') }}
        </h4>
        <v-btn icon x-small @click="$emit('remove-modal')">
          <v-icon size="24">$close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text height="800px" class="px-10 pt-6">
        <div
          class="mb-6 alert-box"
          :class="isVerificationSuccessful ? 'ok' : 'alert'"
        >
            <span class="font-weight-600 mb-0">
              <span v-if="isVerificationSuccessful">
                <i18next
                  :translation="$t('heading.onboarding.domainDnsVerificationModal.message.success')"
                >
                  <template #domain><span class="font-weight-600">{{ domain }}</span></template>
                </i18next>
              </span>
              <span v-else-if="!isRetried">
                <i18next
                  :translation="$t('heading.onboarding.domainDnsVerificationModal.message.incorrect')"
                >
                  <template #domain><span class="font-weight-600">{{ domain }}</span></template>
                </i18next>
              </span>
              <span v-else>{{ $t('heading.onboarding.domainDnsVerificationModal.message.tryAgain') }}</span>
            </span>
        </div>
        <DnsOptions
          :domain="domain"
          :onboardingSubdomain="null"
          :dnsSettings="dnsSettings"
          :ipv4Addresses="ipV4Addresses"
          :hasDnsServer="hasDnsServer"
          :nameservers="nameservers"
          :hostCNames="hostCNames"
          hideTitle
        />
      </v-card-text>

      <v-card-actions class="d-flex flex-column pb-6 px-10 pt-2 mt-4">
        <v-btn
          v-if="!isVerificationSuccessful"
          x-large
          elevation="0"
          color="primary"
          block
          @click="checkDnsPropagation"
          :loading="submitting || loading"
        >{{ $t('button.verifyDomain') }}
        </v-btn>
        <v-btn
          v-else
          x-large
          elevation="0"
          color="primary"
          block
          @click="$emit('domain-verified')"
        >
          <template v-if="installationType !== 'wordpress'">
            {{ $t("button.continue") }}
            <v-icon size="24" class="ml-2">$arrowright</v-icon>
          </template>

          <template v-else-if="hasSelectedServiceAskForSiteName()">
            {{ $t("button.website.set") }}
            <v-icon size="24" class="ml-2">$arrowright</v-icon>
          </template>

          <template v-else>
            {{ $t("button.website.create") }}
            <v-icon size="24" class="ml-2">$arrowright</v-icon>
          </template>
        </v-btn>
        <v-btn
          v-if="!isVerificationSuccessful"
          @click="$emit('domain-verified')"
          x-large
          elevation="0"
          class="mx-0 mt-2"
          color="gray"
          text
          block
        >
          <span class="p-1 font-weight-light gray--text text--darken-1">
            {{ $t('button.skip') }}
          </span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DnsOptions from "../DnsOptions.vue";
import Api from "../../apis/Api";
import OnboardingSelectedServiceMixin from "@/mixins/Onboarding/SelectedServiceMixin";

export default {
  name: "OnboardingDomainInstantVerificationModal",
  components: {DnsOptions},
  mixins: [OnboardingSelectedServiceMixin],
  props: {
    isOpen: [Boolean, String],
    loading: Boolean,
    selectedService: {
      type: Object,
      default: () => {
      },
    },
    selectedTheme: Object,
    domain: String,
    newDomain: Object,
    installationType: { type: String, default: "wordpress" },
  },
  data() {
    return {
      submitting: false,
      isRetried: false,
      isVerificationSuccessful: false,
    }
  },
  computed: {
    nameservers() {
      return this.selectedService.dns_server?.nameservers ?? [];
    },
    hasDnsServer() {
      return this.selectedService.dns_server?.enabled ?? false;
    },
    dnsSettings() {
      return this.selectedService.onboarding?.dns_settings ?? [];
    },
    ipV4Addresses() {
      return this.selectedService.hosting_accounts?.[0]?.ipv4_addresses
          ?? this.selectedService.hosting_server?.ip_v4_addresses
          ?? [];
    },
    hostCNames() {
      return this.selectedService.hosting_accounts.flatMap(account => account.host_c_names)
    }
  },
  methods: {
    async checkDnsPropagation() {
      this.submitting = true;

      try {
        // for UX
        await new Promise(resolve => setTimeout(resolve, 2000));

        let result = await Api.dns().verifyDomainResolving(
          this.domain,
          null,
          this.selectedService.onboarding.dns_settings,
          this.selectedService.dns_server.enabled,
          this.ipV4Addresses,
          this.selectedService.dns_server.nameservers,
          this.selectedService.hosting_accounts.flatMap(account => account.host_c_names),
          this.newDomain?.domain_zone?.details.configuration_records ?? [],
          this.selectedService.onboarding.eager_domain_dns_verification_enabled,
        );
        this.submitting = false;

        if (result) {
          this.isVerificationSuccessful = true;
        } else {
          this.isRetried = true;
        }
      } finally {
        this.submitting = false;
      }
    },
  },
  watch: {
    isOpen: function (value) {
      value
        ? this.$store.dispatch("lockBodyScroll")
        : this.$store.dispatch("unlockBodyScroll");
    },
  },
}
</script>


<style lang="scss" scoped>
.recovery-code-box {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  height: 60px;
  color: var(--v-primary-base);
  background: rgba(7, 192, 126, 0.05);
  border-radius: 6px;
  text-transform: uppercase;
  font-weight: $font-weight-bold;
  word-wrap: anywhere;
  padding: 8px;
  min-height: 80px !important;
}

.main-warning-message {
  background: var(--v-primary-lighten4);
  border-radius: 6px;

  h5 {
    margin: 0;
    font-size: 1.1em;
    color: var(--v-primary-base);

    strong {
      color: var(--v-primary-darken1) !important;
    }
  }
}

.v-dialog__content::v-deep {
  .v-dialog {
    overflow-y: auto;
    overflow-x: hidden;
  }
}

.close-model {
  position: absolute;
  top: -40px;
  right: -8px;
}

.v-card::v-deep {
  .v-card__text {
    -webkit-line-clamp: unset !important;
  }

  @media (max-width: 480px) {
    .v-card__text,
    .v-card__actions {
      padding-left: 24px !important;
      padding-right: 24px !important;
    }
  }
}

.alert-box {
  width: 100%;
  min-width: 100%;
  padding: 16px;
  text-align: center;
  border-radius: 8px;

  &.ok {
    background: var(--v-success-lighten5);
    color: var(--v-success-base);
  }

  &.alert {
    background: var(--v-error-lighten5);
    color: var(--v-error-base);
  }
}

</style>